<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hcontacto">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>CONTACTO</h1>
                    <p>Si quiere dejar algún comentario, estamos para escucharlo.<br/><br/>Deje sus comentarios, le atenderemos a la brevedad.</p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>

    <div class="FcfrCst">
        <div class="FcfrCstInt dSieteM dtDiez dmDoce flx">
            <div class="dDiez dmOnce FcttAzul flx">
                <div class="dSeis dmOnce">
                    <h3>Oficinas centrales</h3>
                    <p class="FcifrasDatos">
                        Independencia No. 26, (Eje 6 Sur, Ángel Urraza)<br>
                        Col. Independencia, C.P. 03630,
                        Alcaldía de Benito Juárez, Ciudad de México
                    </p>
                </div>
                <div class="dSeis dmOnce">
                    <h3>Teléfono:</h3>
                    <p class="FcifrasDatos">
                        Conmutador: 54.22.46.20<br>
                        Interior de la República: 800.508.3580
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="espacioDefault"></div>
    <div class="FformContacto dOcho dtDiez dmOnce">
        <form ngNativeValidate #f="ngForm" (ngSubmit)="mandarContacto(f); f.reset()" class="text-left" *ngIf="this.sendok">
            <div class="row">
                <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="nombre">Nombre</label>
                        <input
                            ngModel
                            name="nombre"
                            name="nombre"
                            type="text"
                            class="form-control text-left"
                            placeholder="Nombre completo"
                            maxlength="80"
                            required
                            style="border: solid 1px; border-color: #cadce6; background-color: #FFFFFF; border-radius: 6px;"
                        />
                </div>
                <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="emailInput">E-mail</label>
                        <input ngModel name="email" name="mail" type="email" maxlength="50" class="form-control text-left" placeholder="Email / Correo electrónico" required style="border: solid 1px; border-color: #cadce6; background-color: #FFFFFF; border-radius: 6px;" />
                </div>
                <div class="form-group col-12 p-0">
                        <label for="asuntoSelect">Selecciona un asunto</label>
                        <select ngModel name="asunto" name="asunto" class="form-control" required style="border: solid 1px; border-color: #cadce6; background-color: #FFFFFF; border-radius: 6px;">
                            <option value="Información de Consultorios">Información de Consultorios</option>
                            <option value="Bolsa de Trabajo">Bolsa de Trabajo</option>
                            <option value="Análisis Clínicos">Análisis Clínicos</option>
                            <option value="Sugerencia">Sugerencia</option>
                            <option value="Queja">Queja</option>
                            <option value="Otro">Otro</option>
                        </select>
                </div>
                <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="fonoInput">Teléfono</label>
                        <input
                            ngModel
                            name="telefono"
                            name="telefono"
                            pattern="\d+"
                            maxlength="10"
                            type="text"
                            class="form-control text-left"
                            placeholder="Teléfono (10 dígitos)"
                            required
                            style="border: solid 1px; border-color: #cadce6; background-color: #FFFFFF; border-radius: 6px;"
                        />
                </div>
                <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                    <label for="estado">Estado</label>
                    <select ngModel name="estado" name="estado" class="form-control" required style="border: solid 1px; border-color: #cadce6; background-color: #FFFFFF; border-radius: 6px;">
                        <option>Escoge una opción</option>
                        <option *ngFor="let item of list" [value]="item.id">{{item.name}}</option>
                    </select>
                </div>
                <div class="col-12 p-0">
                    <div class="form-group">
                        <label for="mensajeTextArea">Mensaje</label>
                        <textarea
                            ngModel
                            name="comentarios"
                            name="comentarios"
                            class="form-control"
                            placeholder="Comentario"
                            rows="6"
                            maxlength="600"
                            style="border: solid 1px; border-color: #cadce6; background-color: #FFFFFF; border-radius: 6px; resize: none;"
                            required
                        ></textarea>
                    </div>
                    <div class="form-group">
                        <input required type="checkbox" id="deacuerdo" value="deacuerdo" style="width: auto;"><label for="deacuerdo" style="width: auto;">&nbsp;&nbsp;
                          Estoy de acuerdo con <a [routerLink]="['/aviso-de-privacidad']">Aviso de Privacidad</a></label><br><br>
                    </div>
                    <div class="text-center center-block">
                        <button id="send" type="submit" class="btn">Enviar</button>
                    </div>
                </div>
            </div>
        </form>
        <div class="col-12 text-center center-block" *ngIf="this.notsendok">
            <p id="agradecimiento">   Muchas gracias, tus comentarios han sido enviados. A la brevedad nos comunicaremos contigo.</p>
        </div>
    </div>
</div>